/**
 * Subscribe to document becoming visible again.
 * No-ops when `document` is unavailable (FastBoot / SSR).
 *
 * @param {() => void} onVisible
 * @returns {() => void} cleanup
 */
export function watchDocumentVisibility(onVisible) {
  if (typeof document === 'undefined' || typeof onVisible !== 'function') {
    return () => {};
  }

  let handler = () => {
    if (document.visibilityState === 'visible') {
      onVisible();
    }
  };

  document.addEventListener('visibilitychange', handler);

  return () => {
    document.removeEventListener('visibilitychange', handler);
  };
}
